export const sectionsToLabel = (sections: string[]) =>
    sections
        .map((item) => `[${item}]`)
        .reverse()
        .join(' > ');

export const sectionsToCategory = (sections: string[]) => sections[0];
